export class Site {
  id: number = -1;
  name: string = '';
  domain: string = '';
  password: string | null = null;
  modules: SiteModule[] = [];
}

export class SiteModule {
  site_id: number = -1;
  type: string = '';
  content: string = '';
  data: SiteData = new SiteData();
}

export class SiteData {
  html: string = '';
  video?: string = '';
  pdf?: string = '';
}
